import { render, staticRenderFns } from "./DocumentsTypeTable.vue?vue&type=template&id=026fbc1a&"
import script from "./DocumentsTypeTable.vue?vue&type=script&lang=js&"
export * from "./DocumentsTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports